import { WeldOrganizationExt } from './types';
import { WeldOrganization } from '@bechtel/types';
import { t } from '@lingui/macro';

export const weldOrgList: WeldOrganizationExt[] = [
  {
    label: t`Weld Pool`,
    value: WeldOrganization.WELD_POOL,
  },
  {
    label: t`Welders are embedded in piping crews`,
    value: WeldOrganization.PIPING_CREW_WELDERS,
  },
  {
    label: t`Hybrid (weld pool & embedded in piping crews)`,
    value: WeldOrganization.HYBRID,
  },
];
